import PropTypes from 'prop-types';
import React from 'react';
import { ModalButton } from '../modal_button/modal_button';

/**
 * Render a modal close icon.
 * @param {Object} args The destructured args
 * @param {Object} args.visualProps The visualProps
 * @param {Object} args.contentProps The contentProps
 * @param {Object} args.eventProps The eventProps
 * @param {Object} args.elementProps The elementProps
 * @param {Function} args.onClickFunction The onClickFunction passed to button
 * @returns {Node} A ModalCloseIcon component
 * @constructor
 */
const ModalCloseIcon = ({ visualProps = {}, contentProps = {}, eventProps = {}, elementProps = {}, onClickFunction }) => {
    return (
        <ModalButton
            onClickFunction={onClickFunction}
            eventProps={eventProps}
            contentProps={contentProps}
            visualProps={visualProps}
            elementProps={{ 'data-id': 'modalCloseIcon', ...elementProps }}
        />
    );
};

ModalCloseIcon.propTypes = {
    contentProps: PropTypes.object,
    visualProps: PropTypes.object,
    elementProps: PropTypes.object,
    eventProps: PropTypes.object,
    onClickFunction: PropTypes.func
};

ModalCloseIcon.defaultProps = {
    visualProps: {
        variant: 'modal_close_icon'
    },
    contentProps: {
        icon: 'ctm_cross',
        iconColor: 'brand_primary'
    }
};

export { ModalCloseIcon };
